import { render, staticRenderFns } from "./CommonNotification.vue?vue&type=template&id=267f7062&scoped=true"
import script from "./CommonNotification.vue?vue&type=script&lang=js"
export * from "./CommonNotification.vue?vue&type=script&lang=js"
import style0 from "./CommonNotification.vue?vue&type=style&index=0&id=267f7062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f7062",
  null
  
)

export default component.exports